import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import map from 'lodash/map';

import { FormattedMessage } from 'react-intl';

import Loading from 'components/Loading';
import PanelMessage from 'components/panels/PanelMessage';
import TransportationGrant from './TransportationGrant';

import { fetch, register } from './actions';
import KTitle from '../../components/KJRN/KTitle';

const duplicateRegister =
  'Employee has an active EmployeeMasterTransportation contract';

const styles = {
  container: {
    paddingTop: 16,
    paddingBottom: 16,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 1344,
    margin: 'auto',
  },
  titleContainer: {
    width: '100%',
  },
  list: {
    paddingBottom: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: 1344,
    margin: 'auto',
  },
};

class TransportationGrants extends Component {
  componentDidMount() {
    const { fetchGrants } = this.props;
    fetchGrants();
  }

  render() {
    const {
      grantsLoading,
      grantsError,
      grantRegister,
      transportationGrants,
      registerError,
      registerLoadingById,
    } = this.props;

    if (grantsLoading) {
      return <Loading />;
    }

    if (grantsError) {
      return (
        <PanelMessage
          message={
            <FormattedMessage
              id="transportationGrants.error"
              values={{ error: grantsError }}
            />
          }
          iconName="error"
          type="error"
        />
      );
    }

    if (registerError && registerError !== duplicateRegister) {
      return (
        <PanelMessage
          message={
            <FormattedMessage
              id="transportationGrants.error"
              values={{ error: registerError }}
            />
          }
          iconName="error"
          type="error"
        />
      );
    }

    if (!grantsError && transportationGrants && !transportationGrants.length) {
      return (
        <PanelMessage
          message={<FormattedMessage id="transportationGrants.empty" />}
          iconName="info"
          type="info"
        />
      );
    }

    return (
      <div style={styles.container}>
        {registerError === duplicateRegister ? (
          <PanelMessage
            message={<FormattedMessage id="transportationGrants.duplicate" />}
            iconName="warning"
            type="warning"
          />
        ) : null}
        <KTitle containerStyle={styles.titleContainer} title={<FormattedMessage id="tile.transportations.title" />} />

        {map(
            transportationGrants,
            grant => (
              <div style={{ margin: 12 }}>

                <TransportationGrant
                  key={grant.HrTransportationGrantID}
                  loading={registerLoadingById[grant.HrTransportationGrantID]}
                  onSubmit={grantRegister}
                  grant={grant}
                />
              </div>
            ),
          )}
      </div>
    );
  }
}

TransportationGrants.propTypes = {
  fetchGrants: PropTypes.func.isRequired,
  grantRegister: PropTypes.func.isRequired,
  registerError: PropTypes.string,
  registerLoadingById: PropTypes.objectOf(PropTypes.bool).isRequired,
  grantsError: PropTypes.string,
  grantsLoading: PropTypes.bool.isRequired,
  transportationGrants: PropTypes.arrayOf(PropTypes.shape({
    HrTransportationGrantID: PropTypes.number.isRequired,
    HrTransportationGrantName: PropTypes.string.isRequired,
    PublicTransportation: PropTypes.string,
    Cycling: PropTypes.string,
    Walking: PropTypes.string,
    TransportationCard: PropTypes.string,
    Months: PropTypes.number,
    AmountPerMonth: PropTypes.string,
  })).isRequired,
};

TransportationGrants.defaultProps = {
  grantsError: null,
  registerError: null,
};

export default connect(
  ({ TransportationGrantReducer }) => ({ ...TransportationGrantReducer }),
  dispatch => ({
    fetchGrants: () => dispatch(fetch()),
    grantRegister: transportGrant => dispatch(register(transportGrant)),
  }),
)(TransportationGrants);



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/TransportationGrants.js